import { useContext } from "react";
import { useLocation } from "react-router-dom";

import { CategoryMeta } from "../CategoryMeta";
import { WithTooltip } from "../../StyledComponents/WithTooltip";
import { useSubCategories } from "../../../hooks/apis/useSubCategories";
import { getCategoryIcon } from "../utils";
import { KBContext } from "../../../Context";
import { SubCategoriesLoader } from "../../Loaders/SubCategories";

// styles
import { Wrapper, SubCategory, Content, Title } from "./styles";


export const SubCategories = ({ selectedCategory, ...props }) => {

    const categorySlug = selectedCategory?.slug;
    const { data: { brandColor } } = useContext(KBContext);
    const { search } = useLocation();

    const { data: subCategories = [], isLoading } = useSubCategories({ categorySlug });

    if( isLoading ) {
        return <SubCategoriesLoader count={ selectedCategory?.immediateSubcategoryCount ?? 4 } { ...props } />;
    }

    if( !subCategories?.length ) {
        return null;
    }

    return (
        <Wrapper {...props}>
            { subCategories.map( (subCategory) => (
                <SubCategory
                    style={{ textDecoration: "none" }}
                    key={subCategory.categoryId}
                    to={`/${subCategory.slug}` + search}
                >
                    {getCategoryIcon({ icon: subCategory.icon, color: brandColor })}
                    <Content>
                        <WithTooltip isNeeded={subCategory.title.length > 14} content={subCategory.title} size="200px">
                            <Title>{subCategory.title}</Title>
                        </WithTooltip>
                        <CategoryMeta categoryData={subCategory} />
                    </Content>
                </SubCategory>
            ))}
        </Wrapper>
    )
}